"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fingerprint = void 0;
const fingerprintjs_pro_1 = require("@fingerprintjs/fingerprintjs-pro");
const logger_1 = require("../class/logger");
const local_data_1 = require("./local-data");
const TWENTY_FOUR_HOURS = 1000 * 60 * 60 * 24;
class Fingerprint {
    constructor(args) {
        this.args = args;
        this.setup();
    }
    identify() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const localFP = this.localFingerprint;
            if (localFP) {
                return localFP;
            }
            try {
                this.fingerprintPromise =
                    (_a = this.fingerprintPromise) !== null && _a !== void 0 ? _a : new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            const fpjs = yield this.fpPromise;
                            const result = yield fpjs.get();
                            resolve(result);
                        }
                        catch (err) {
                            reject(err);
                        }
                    }));
                const result = yield this.fingerprintPromise;
                this.localFingerprint = result === null || result === void 0 ? void 0 : result.visitorId;
                return result.visitorId;
            }
            catch (err) {
                logger_1.Logger.handle(err);
            }
            return '';
        });
    }
    get localFingerprint() {
        var _a;
        if (local_data_1.LocalData.hasStorage) {
            const result = local_data_1.LocalData.readStorage(local_data_1.StorageKeys.fingerprint);
            if (!result) {
                return null;
            }
            return result.e > Date.now() ? (_a = result.i) !== null && _a !== void 0 ? _a : null : null;
        }
        return null;
    }
    set localFingerprint(value) {
        if (value === undefined) {
            return;
        }
        if (local_data_1.LocalData.hasStorage) {
            if (value == null) {
                local_data_1.LocalData.deleteStorage(local_data_1.StorageKeys.fingerprint);
                return;
            }
            local_data_1.LocalData.writeStorage(local_data_1.StorageKeys.fingerprint, {
                i: value,
                e: Date.now() + TWENTY_FOUR_HOURS,
            });
        }
    }
    setup() {
        var _a, _b;
        const fpOps = {
            apiKey: this.args.apiKey,
            region: 'us',
            scriptUrlPattern: [
                ...(this.args.scriptUrls || []),
                fingerprintjs_pro_1.defaultScriptUrlPattern,
            ],
        };
        fpOps.endpoint = (_a = this.args.endpoint) !== null && _a !== void 0 ? _a : fingerprintjs_pro_1.defaultEndpoint;
        this.fpPromise = (_b = this.fpPromise) !== null && _b !== void 0 ? _b : (0, fingerprintjs_pro_1.load)(fpOps);
    }
}
exports.Fingerprint = Fingerprint;
